/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Address } from './Address';
export type RegisterPublicSeminarPayload = {
    paymentType?: RegisterPublicSeminarPayload.paymentType;
    email: string;
    firstName: string;
    lastName: string;
    fingerprint: string;
    phoneNumber?: string;
    address?: Address;
    birthdate?: string;
    seats?: number;
    note?: string;
    source?: RegisterPublicSeminarPayload.source;
};
export namespace RegisterPublicSeminarPayload {
    export enum paymentType {
        ONLINE = 'online',
        CASH = 'cash',
        INVOICE = 'invoice',
    }
    export enum source {
        WIDGET = 'widget',
        PUBLIC_PAGE = 'public_page',
    }
}

